import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { GenericResponse, Utente } from 'src/app/entities/various';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtenteService {

  private e_invoiceUrl: string = environment.url;
  //private e_invoiceUrl: string = AppConfig.settings.apiServer.url;

  constructor(private http: HttpClient) { }

  async getServiziAttivi(userId: string): Promise<GenericResponse> {
      return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + userId + "/services")
        .toPromise()
        .then((data: any) => {
          return data;
        });
  
    }

    async controlloPartitaIva(piva: string) {
    let body = { partita_iva: piva };
    return await this.http.post<GenericResponse>(this.e_invoiceUrl + '/api/v1/users/checkIva', body)
    .toPromise()
      .then((data: any) => {
        return data;
      }).catch(() => {
      });
  }

    async registraUtente(utente: Utente): Promise<GenericResponse> {
      return await this.http.post(this.e_invoiceUrl + "/api/v1/users/registrazione", utente)
        .toPromise()
        .then((data: any) => {
          return data;
        });
    }

    async getUtente(userId: string | number): Promise<GenericResponse> {
      return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + userId + "/dettaglio")
        .toPromise()
        .then((data: any) => {
          return data;
        });
    }

    async ricercaUtente(userId: number | string, params: HttpParams): Promise<GenericResponse> {
      return await this.http.get(this.e_invoiceUrl + "/api/v1/users/" + userId + "/ricerca", { params: params })
        .toPromise()
        .then((data: any) => {
          return data;
        });
    }

    async aggiornaProfilo(utente: Utente): Promise<GenericResponse> {
      return await this.http.put(this.e_invoiceUrl + "/api/v1/users/" + utente.user_id + "/profilo", utente)
        .toPromise()
        .then((data: any) => {
          return data;
        }
      );
    }

    async aggiornaPassword(userId: any, body: any): Promise<GenericResponse> {
      return await this.http.put(this.e_invoiceUrl + "/api/v1/users/" + userId + "/profilo/password", body)
        .toPromise()
        .then((data: any) => {
          return data;
        });

    }

    async dettagliFatturazione(user_id: number): Promise<GenericResponse> {
      return await this.http.get(this.e_invoiceUrl + "/api/v1/services/" + user_id + "/fatturazione")
        .toPromise()
        .then((data: any) => {
          return data;
        }
      );
    }

    async invioNotifiche(user_id: number, notifiche: any): Promise<GenericResponse> {
      return await this.http.put(this.e_invoiceUrl + "/api/v1/services/" + user_id + "/invio_notifiche", notifiche)
        .toPromise()
        .then((data: any) => {
          return data;
        }
      );
    }

    async modificaServizio(user_id: number, type: string, value: boolean): Promise<GenericResponse> {
      let body = { servizio: type, is_active: value };
      return await this.http.put(this.e_invoiceUrl + "/api/v1/services/" + user_id + "/modifica_servizio", body)
        .toPromise()
        .then((data: any) => {
          return data;
        }
      );
    }

    async caricaLogo(user_id: number, body: any): Promise<GenericResponse> {
      return await this.http.post(this.e_invoiceUrl + '/api/v1/users/' + user_id + '/profilo', body)
        .toPromise()
        .then((data: any) => {
          return data;
        });
    }

}
